import React from 'react';
import Marquee from 'react-fast-marquee';
import './NewsTicker.css'; // Import the CSS file
import siteLogo from '../../common/assets/images/footerlogo.png';
import styles from './index.module.less';
// import axios from 'axios';

const NewsTicker = () => {
  //   const [news, setNews] = useState([]);

  return (
    <div>
      <Marquee
        pauseOnHover
        gradient={false}
        speed={40}
        loop={0}
        autoFill={true}
      >
        {/* <div style={{ marginRight: '1000px' }}> */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginRight: '1000px'
          }}
        >
          <img
            src={siteLogo}
            alt="First Image"
            style={{ height: '25px', marginRight: '15px' }}
          />
          <h3
            className={styles.h3styles}
            // style={{
            //   color: '#faf1d9',
            //   padding: '10px',
            //   marginBottom: '0em',
            //   marginTop: '0px',
            //   fontSize: '14px',
            //   fontWeight: 'normal',
            //   fontFamily: 'Teachers'
            // }}
          >
            Limited-Time Offer! FIRST 1000 SUBSCRIPTIONS are GST FREE! Subscribe
            now and save—don`t miss out!
          </h3>
        </div>
      </Marquee>
    </div>
  );
};

export default NewsTicker;
